module.exports = __webpack_public_path__ + "img/oldschool1.jpg";